import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as queryString from 'query-string'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import BasicLayout from '../../layouts/BasicLayout'
import { dispatch, RootState, select, store } from '../../store'
import PaymentPageAside from './aside'
import PaymentPageMain from './main'
import paymentStyles from './payment-page.scss'

const cx = classnames.bind(paymentStyles)

interface IProps extends
  ReturnType<typeof mapState>,
  RouteComponentProps<any> {
}

class PaymentPage extends React.Component<IProps> {
  public handleCheckout = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    dispatch.payment.checkout()
  }
  public componentDidMount = () => {
    const lectureId = this.getLectureId()
    dispatch.payment.updateLectureId(lectureId)
    dispatch.payment.checkout()
  }
  public render() {
    const rootState = store.getState()
    const { location } = this.props
    const queries = queryString.parse(location.search)
    const { lectureId } = queries
    const lecture = select.lectures.getById(rootState, lectureId)
    const speakers = lecture ? lecture.speakerIds.map(speakerId => select.users.getById(rootState, speakerId)) : []
    return (
      <BasicLayout className={cx('page-Payment')}>
        <div className={cx('container')}>
          <form className={cx('payment-form')} onSubmit={this.handleCheckout}>
            <div className={cx('row')}>
              <div className={cx('col-lg-8')}>
                <PaymentPageMain lecture={lecture} />
              </div>
              <div className={cx('col-lg-4')}>
                <PaymentPageAside
                  lecture={lecture}
                  speakers={speakers}
                  onPaymentSubmit={dispatch.payment.createOrder} />
              </div>
            </div>
          </form>
        </div>
      </BasicLayout>
    )
  }
  private getLectureId = () => {
    const { location } = this.props
    const queries = queryString.parse(location.search)
    const { lectureId } = queries
    return lectureId
  }
}

const mapState = ({ lectures, users }: RootState) => {
  const rootState = store.getState()
  const fbCurrentUser = firebase.auth().currentUser
  const currentUser = fbCurrentUser ? select.users.getById(rootState, fbCurrentUser.uid) : null
  return {
    lectures, currentUser
  }
}

export default connect(mapState)(PaymentPage)



// WEBPACK FOOTER //
// ./src/pages/PaymentPage/index.tsx